// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'

/**
 上传ZIP文件
 */
export function uploadTaskCreate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/uploadTask/create',
    method: 'post',
    data,
  })
}

/**
 上传文件历史记录列表
 */
export function uploadTaskGetPage(data = {}) {
  return request({
    url: '/admin/v1/vehicle/uploadTask/getPage',
    method: 'post',
    data,
  })
}

/**
 上传文件错误详情
 */
export function uploadTaskGetDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/uploadTask/getDetail',
    method: 'post',
    data,
  })
}

// 批量收款新增
export function addRecordReceivable(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/record/add',
    method: 'post',
    data,
  })
}

// 批量付款新增
export function addRecordPayment(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/record/add',
    method: 'post',
    data,
  })
}

// 获取权限内所有公司列表
export function getAdminUserCompany(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/dropDownList',
    method: 'post',
    data,
  })
}
